document.addEventListener( 'DOMContentLoaded', function() {
  var event = new Event('theme_script_loaded');
  document.dispatchEvent(event);
} );